import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import YourFreelanceStory from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <YourFreelanceStory />
  </React.StrictMode>
);
